import {
    GET_ANONYMOUS_EXAM_RECORDS_FAIL,
    GET_ANONYMOUS_EXAM_RECORDS_SUCCESS,
    ADD_ANONYMOUS_EXAM_RECORD_SUCCESS,
    ADD_ANONYMOUS_EXAM_RECORD_FAIL,
    UPDATE_ANONYMOUS_EXAM_RECORD_SUCCESS,
    UPDATE_ANONYMOUS_EXAM_RECORD_FAIL,
    DELETE_ANONYMOUS_EXAM_RECORD_SUCCESS,
    DELETE_ANONYMOUS_EXAM_RECORD_FAIL,

    GET_ANONYMOUS_RECORDS_FOR_TEACHER,
    GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS,
    GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAIL,

  // LAST ADD FOR SEARCH BY BARCODE
    GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE,
    GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_SUCCESS,
    GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_FAIL,
    UPDATE_ANONYMOUS_EXAM_RECORD_NOTE,
    UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_SUCCESS,
    UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_FAIL,


} from "./actionTypes";

const INIT_STATE = {
    anonymousExamRecords: [],
    recordsForTeacher: [],
    error: null,
    loading: false,
    lastActionSuccess: false,
    currentRecord: null,  // 🔹 Nouveau state pour le record en cours
};

const anonymousExamRecordReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des anonymousExamRecords
        case GET_ANONYMOUS_EXAM_RECORDS_SUCCESS:
            return {
                ...state,
                anonymousExamRecords: action.payload.anonymousExamRecords, // tableau d'objets anonymousExamRecord
                loading: false,
                error: null
            };

        case GET_ANONYMOUS_EXAM_RECORDS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une anonymousExamRecorde
        case ADD_ANONYMOUS_EXAM_RECORD_SUCCESS:
            return {
                ...state,
                anonymousExamRecords: [action.payload, ...state.anonymousExamRecords], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true
            };

        case ADD_ANONYMOUS_EXAM_RECORD_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Mise à jour d'une anonymousExamRecorde
        case UPDATE_ANONYMOUS_EXAM_RECORD_SUCCESS:
            return {
                ...state,
                anonymousExamRecords: state.anonymousExamRecords.map(anonymousExamRecord =>
                    anonymousExamRecord.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet anonymousExamRecord
                        : anonymousExamRecord
                ),
                error: null,
                lastActionSuccess: true
            };

        case UPDATE_ANONYMOUS_EXAM_RECORD_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Suppression d'une anonymousExamRecorde
        case DELETE_ANONYMOUS_EXAM_RECORD_SUCCESS:
            return {
                ...state,
                anonymousExamRecords: state.anonymousExamRecords.filter(
                    anonymousExamRecord => anonymousExamRecord.id !== action.payload
                ),
                error: null
            };


        case DELETE_ANONYMOUS_EXAM_RECORD_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };

        // Début récupération
        case GET_ANONYMOUS_RECORDS_FOR_TEACHER:
        return {
            ...state,
            loading: true,
            error: null,
            lastActionSuccess: false,
        };

        // Récupération réussie
        case GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS:
        return {
            ...state,
            recordsForTeacher: action.payload, // tableau d'objets
            loading: false,
            error: null,
        };

        // Erreur récupération
        case GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAIL:
        return {
            ...state,
            error: action.payload,
            loading: false,
        };

        // LAST ADD FOR SEARCH BY BARCODE
        // Recherche par code-barre
        case GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE:
            return {
                ...state,
                loading: true,
                error: null,
                currentRecord: null,
            };

        case GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_SUCCESS:
            return {
                ...state,
                loading: false,
                currentRecord: action.payload,
                error: null,
            };

        case GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                currentRecord: null,
            };

        // Mise à jour de note
        case UPDATE_ANONYMOUS_EXAM_RECORD_NOTE:
            return {
                ...state,
                loading: true,
                error: null,
                lastActionSuccess: false,
            };

        case UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_SUCCESS:
            return {
                ...state,
                loading: false,
                currentRecord: action.payload,
                lastActionSuccess: true,
                error: null,
            };

        case UPDATE_ANONYMOUS_EXAM_RECORD_NOTE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                lastActionSuccess: false,
            };

        default:
            return state;
    }
};

export default anonymousExamRecordReducer;
